/**
 * TODO: add more listing mappings
 * @type {{partner: number}}
 */
export const listingAttributesHelper = {
  partner: 13372,
};

/**
 * Helper function to determine whether the ticket is from primary partner or not
 * @param {Array} listingAttributeList - list of ticket attributes
 * @return {(boolean|arg is Array<any>)|*}
 */
export const hasPartnerTicketAttribute = (listingAttributeList) =>
  !!listingAttributeList &&
  Array.isArray(listingAttributeList) &&
  listingAttributeList.includes(listingAttributesHelper.partner);
